module.exports = __webpack_public_path__ + "static/img/nav.244a6ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav.png
// module id = aTLc
// module chunks = 0